import { render } from "./NewGuardianChat.vue?vue&type=template&id=2fccf1fa&scoped=true"
import script from "./NewGuardianChat.vue?vue&type=script&lang=js"
export * from "./NewGuardianChat.vue?vue&type=script&lang=js"

import "./NewGuardianChat.vue?vue&type=style&index=0&id=2fccf1fa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fccf1fa"]])

export default __exports__